import React from "react";
import {Card, CardBody, Col, Row, Button, Container} from "reactstrap";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useTemplateHistory } from "../../features/template-history/hooks/useTemplateHistory";
import { TemplateHistoryFiltersComp } from "../../features/template-history/components/TemplateHistoryFilters";
import { TemplateHistoryTable } from "../../features/template-history/components/TemplateHistoryTable";

const TemplateHistoryPage = () => {
    document.title = "Historial de Plantillas | Tren Taita Imbabura";

    const {
        list,
        total,
        isLoading,
        filters,
        handlePageChange,
        handleFilterChange,
        refresh
    } = useTemplateHistory();

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <div className="d-flex align-items-center mt-4 mb-2">
                                    <h5 className="card-title mb-0 flex-grow-1 text-center fw-bold">
                                        HISTORIAL DE PLANTILLAS
                                    </h5>
                                </div>
                                <CardBody className="mt-2">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <Link to="/customers">
                                            <Button color="light">
                                                <i className="ri-arrow-left-line me-1"></i> Volver
                                            </Button>
                                        </Link>
                                        <div className="d-flex gap-2 flex-wrap align-items-center">

                                            <Button color="primary"
                                                    onClick={refresh}
                                                    disabled={isLoading}>
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <i className="ri-refresh-line me-1"></i>
                                                )}
                                                Actualizar
                                            </Button>
                                        </div>
                                    </div>
                                    
                                    <TemplateHistoryFiltersComp
                                        filters={filters}
                                        onChange={handleFilterChange}
                                    />

                                    <div className="mt-4">
                                        <TemplateHistoryTable
                                            data={list}
                                            total={total}
                                            filters={filters}
                                            isLoading={isLoading}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                    <ToastContainer closeButton={false} limit={1} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TemplateHistoryPage;
